import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

require('classlist-polyfill');
require('react-datepicker/dist/react-datepicker.css');


class DocketFilters extends Component {
  changeText = (e) => {
    this.props.filterTable(e);
    this.props.onChange(e, 'keyword');
  }

  keydown = (e) => {
    // only respond to tabbing through or enter.
    // Sometimes we need to blur out for other clicks that dont trigger a buy (ie cancel button)
    if (e.keyCode === 13 || e.keyCode === 9) {
      const { startDate, endDate, doc_range, keyword } = this.props;
      const params = { startDate, endDate, doc_range, keyword };
      this.props.buyFilteredDockets(params);
    }
  }

  render() {
    const {
      keyword,
      doc_range,
      startDate,
      endDate,
      changeDate,
      onChangeDateRaw,
      onChange,
      onClear,
      buyFilteredDockets,
    } = this.props;

    return (
      <div id="docket-filters">
        <form id="parser-docket-form" onSubmit={buyFilteredDockets}>
          <input type="text"
                 name="keyword"
                 id="alfresco-keyword"
                 className="form-text"
                 size="30"
                 value={keyword}
                 onKeyDown={this.keydown}
                 onChange={this.changeText}
                 placeholder="Enter Keywords" />

          <input type="text"
                 name="doc_range"
                 id="alfresco-doc-range"
                 size="20"
                 className="form-text valid"
                 value={doc_range}
                 onChange={e => onChange(e, 'doc_range')}
                 onKeyDown={this.keydown}
                 placeholder="Doc# Ex: 1,3,4-7" />

          <div className="date-selector">
            <DatePicker selected={startDate}
                        onChange={changeDate.bind(null, 'startDate')}
                        dateFormat="MM/DD/YYYY"
                        className=""
                        placeholderText="date"
                        onChangeRaw={onChangeDateRaw.bind(null, 'startDate')} />
          </div>

          <span>&nbsp;to&nbsp;</span>

          <div className="date-selector">
            <DatePicker selected={endDate}
                        onChange={changeDate.bind(null, 'endDate')}
                        dateFormat="MM/DD/YYYY"
                        className=""
                        placeholderText="date"
                        onChangeRaw={onChangeDateRaw.bind(null, 'endDate')} />
          </div>

          <button type="submit" className="form-submit" value="Submit">
            <span className="magnifier icon" />
          </button>
          <div id="alfresco-clear" className="clear-button" onClick={onClear}>
            clear
          </div>
        </form>
      </div>
    );
  }
}

DocketFilters.defaultProps = {
  startDate: null,
  endDate: null,
};

DocketFilters.propTypes = {
  keyword: PropTypes.string.isRequired,
  doc_range: PropTypes.string.isRequired,
  changeDate: PropTypes.func.isRequired,
  onChangeDateRaw: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  filterTable: PropTypes.func.isRequired,
  buyFilteredDockets: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default DocketFilters;




/** WEBPACK FOOTER **
 ** ./src/components/case/docket/DocketFilters.jsx
 **/